﻿import $ from "jquery";
import c from "./consts";

import Microsoft365 from "./Microsoft365";

export default class Microsoft365PromoExtraTime extends Microsoft365 {
	constructor(o, $ep) {
		super(...arguments);

		this.promo = o.promo;

		this.$contents = $ep.find(c.contentsSelector);
		this.$header = this.$contents.find(".ccs-logo-ms365-header");
		this.$footer = this.renderFooter();

		this.renderHeader();
		this.renderCardText();

		this._mainTabClick = this.mainTabClick;
		this.mainTabClick = this.mainTabClickOverride;
	}

	renderFooter() {
		const footerHtml =
			`<div class="ccs-logo-ms365-footer">
				<div class="ccs-logo-ms365-footer-extratime">${this.promo.footerText}</div>
			</div>`;

		return $(footerHtml).appendTo(this.$contents);
	}

	renderHeader() {
		$(".ccs-logo-ms365-microsoft.ccs-logo-ms365-header-logo").remove();
		const headerHtml =
			`<div class="ccs-logo-ms365-header-logo-img"></div>
			<div class="ccs-logo-ms365-office-is-microsoft-now">${this.promo.headerText}</div>`;
		this.$header.find(".ccs-logo-ms365-main-tabs").append($(headerHtml));
	}

	renderCardText() {
		var $cards = this.$contents.find(".ccs-logo-ms365-card");
		$cards.each((_, card) => {
			var $card = $(card);

			if ($card.attr("data-promo-type") === this.promo.type &&
				$card.attr("data-product-type") === this.promo.productType) {
				if ($card.attr("data-family") === this.promo.productFamily) {
					const cardHtml =
						`<div class="ccs-logo-ms365-extratime-card">
						${this.promo.cardText}
					</div>`;
					$(cardHtml).appendTo($card);
				}
				else {
					$card.addClass("ccs-logo-ms365-card__without-promo");
				}
			}
		});
	}

	mainTabClickOverride(el) {
		this._mainTabClick(el);

		var active = $(el).attr("data-action-context");
		if (active === this.promo.productType) {
			this.$footer.show();
		}
		else {
			this.$footer.hide();
		}
	}
}
